
import React from 'react';
import { Toaster } from '@/components/ui/sonner';
import { useAuthContext } from '../context/AuthContext';
import { BottomNav } from './BottomNav';
import { LanguageSelector } from './LanguageSelector';
import { NotificationBell } from './NotificationBell';
import { Calendar } from 'lucide-react';

export function Layout({ children, activeTab, setActiveTab, role, scheduledCount = 0, onScheduledClick }) {
  const { user } = useAuthContext();
  return (
    <div
      className="min-h-screen bg-gradient-to-b from-teal-50 to-white flex flex-col"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {/* Header - fixed height */}
      <div className="flex-shrink-0 px-4 py-4">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center justify-between py-3">
            <div className="flex items-center gap-3">
              <img 
                src="/logo-header.png" 
                alt="PayMig" 
                className="w-10 h-10 rounded-lg shadow-sm object-contain"
                style={{ imageRendering: 'crisp-edges' }}
              />
              <h1 className="text-lg sm:text-2xl font-semibold text-teal-700">PayMig</h1>
            </div>
            <div className="flex items-center gap-3">
              <LanguageSelector variant="minimal" />
              <NotificationBell />
              {/* Calendar icon with scheduled payments badge */}
              {user && (user.role === 'parent' || user.user_type === 'PAYER' || user.user_type === 'PERSONAL') && (
                <button 
                  onClick={onScheduledClick}
                  className="relative p-2 rounded-full hover:bg-teal-100 transition-colors"
                  data-testid="scheduled-payments-btn"
                  aria-label="Scheduled Payments"
                >
                  <Calendar className="h-5 w-5 text-teal-700" />
                  {scheduledCount > 0 && (
                    <span
                      className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center text-xs font-bold text-white bg-orange-500 rounded-full"
                      data-testid="scheduled-payments-count"
                    >
                      {scheduledCount > 9 ? '9+' : scheduledCount}
                    </span>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      
      {/* Main content - scrollable */}
      <div
        className="flex-1 overflow-y-auto px-4"
        style={{ paddingBottom: 'calc(112px + env(safe-area-inset-bottom))' }}
      >
        <div className="max-w-6xl mx-auto">
          {children}
        </div>
      </div>
      
      <BottomNav activeTab={activeTab} setActiveTab={setActiveTab} role={role} />
      <Toaster richColors />
    </div>
  );
}
